import React from 'react';

function Header(): JSX.Element {
  return (
    <header>
      <h1 className="pt-12 text-2xl leading-7 font-bold text-gray-900 sm:text-3xl">
        CRTM Card Status
      </h1>
      <p className="mt-2 text-gray-600">
        Get the status of fares (like the monthly pass) stored on your CRTM
        card.
      </p>
    </header>
  );
}

export default React.memo(Header);
